
import React from 'react'
import { Col, Row } from 'react-bootstrap'
import ClientsList from '../../components/admin-component/clients/ClientsList'
import ClientStats from '../../components/admin-component/clients/ClientStats'
import Caption from '../../components/baseui/Caption'
import HeaderMain from '../../components/layouts/HeaderMain'


const ClientsHome = () => {
  return (
    <>
    <HeaderMain />
    <div className="main-dashboard">
      <div className="mainWrapper">
        <div className="contentMain">
          <div className="pageTitle">
            <Row className='align-items-center'>
              <Col lg="9">
                <Caption heading1="Clients" />
              </Col>
            </Row>
          </div>
          <ClientStats/>
          <ClientsList/>
        </div>
      </div>
    </div>
  </>
  )
}

export default ClientsHome



